import { useState, useMemo } from "react";
import { FaEdit, FaTrash, FaExternalLinkAlt } from "react-icons/fa";
import HoverTitle from "../HoverTitle";
import { ChevronDown, ChevronUp } from "lucide-react";
import { Link } from "react-router-dom";
import LinearLayout from "../layout/LinearLayout";
const ProductTable = ({
  products,
  categories,
  brands,
  onEdit,
  onDelete,
  onShow,
  onClose,
}) => {
  const [search, setSearch] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [sortField, setSortField] = useState("title");
  const [sortAsc, setSortAsc] = useState(true);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(5);
  const [expanded, setExpanded] = useState(null);
  // console.log("categories=" + categories);
  const toggleSort = (field) => {
    if (sortField === field) {
      setSortAsc(!sortAsc);
    } else {
      setSortField(field);
      setSortAsc(true);
    }
  };
  const toggleExpand = (id) => {
    setExpanded((prev) => (prev === id ? null : id));
  };
  const getCategoryTitle = (categoryId, catarr) => {
    const category = catarr.find((cat) => cat._id === categoryId);
    // console.log("categoriesس =", catarr);
    // console.log("id =", categoryId);
    // console.log("category =", categories);

    // ببینی مثلاً "number" یا "string" هست
    return category ? category.name : "-";
  };
  const getBrandTitle = (brandId, brandarr) => {
    const brand = brandarr.find((cat) => cat._id === brandId);
    // console.log("categoriesس =", catarr);
    // console.log("id =", categoryId);
    // console.log("category =", categories);

    // ببینی مثلاً "number" یا "string" هست
    return brand ? brand.name : "-";
  };
  const getimage = (image) => {
    // console.log("categoriesس =", catarr);
    // console.log("id =", categoryId);
    console.log("image =", image);

    // ببینی مثلاً "number" یا "string" هست
    return "-";
  };
  const filteredProducts = useMemo(() => {
    let result = [...products];

    if (search) {
      result = result.filter((p) =>
        p.title.toLowerCase().includes(search.toLowerCase())
      );
    }
    if (selectedCategory) {
      const categoryid = categories.find(
        (cat) => cat.name === selectedCategory
      );
      //   console.log("selectedCategory=" + categoryid._id);
      result = result.filter(
        (p) => String(p.categoryId) === String(categoryid._id)
      );
    }
    result.sort((a, b) => {
      const aVal = a[sortField];
      const bVal = b[sortField];
      if (aVal < bVal) return sortAsc ? -1 : 1;
      if (aVal > bVal) return sortAsc ? 1 : -1;
      return 0;
    });

    return result;
  }, [products, search, selectedCategory, sortField, sortAsc]);

  const pagedProducts = useMemo(() => {
    const start = (page - 1) * perPage;
    return filteredProducts.slice(start, start + perPage);
  }, [filteredProducts, page, perPage]);

  const toggleSelectRow = (id) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  };

  return (
    <div>
      <div className="d-flex gap-2 mb-3">
        <input
          className="form-control"
          placeholder="Search..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <select
          className="form-select"
          value={selectedCategory}
          onChange={(e) => setSelectedCategory(e.target.value)}
        >
          <option value="">All Categories</option>
          {categories.map((cat) => (
            <option key={cat.id} value={cat.id}>
              {cat.name}
            </option>
          ))}
        </select>
        <select
          className="form-select"
          value={perPage}
          onChange={(e) => setPerPage(Number(e.target.value))}
        >
          {[5, 10, 15, 20].map((n) => (
            <option key={n} value={n}>
              {n} per page
            </option>
          ))}
        </select>
      </div>
      <div className="container-fluid px-2">
        {/* Desktop Table */}
        <div className="d-none d-lg-block">
          <table className="table table-striped w-100 table-hover">
            <thead >
              <tr>
                <th>#</th>
                <th className="fs-6"
                  onClick={() => toggleSort("title")}
                  style={{ cursor: "pointer" }}
                >
                  Title
                </th>
                <th className="fs-6"
                  onClick={() => toggleSort("categoryId")}
                  style={{ cursor: "pointer" }}
                >
                  Category
                </th>
                <th className="fs-6"
                  onClick={() => toggleSort("price")}
                  style={{ cursor: "pointer" }}
                >
                  Price
                </th>
                <th className="fs-6"
                  onClick={() => toggleSort("discount")}
                  style={{ cursor: "pointer" }}
                >
                  Discount
                </th>
                <th className="fs-6"
                  onClick={() => toggleSort("stock")}
                  style={{ cursor: "pointer" }}
                >
                  Stock
                </th>
                <th className="fs-6">Keywords</th>
                <th className="fs-6">Size</th>
                <th className="fs-6">Brand</th>
                <th className="fs-6">Actions</th>
              </tr>
            </thead>
            <tbody>
              {pagedProducts.map((product, index) => (
                <tr key={product._id}>
                  <td>
                    <td onClick={() => onShow(product)}>
                      {(page - 1) * perPage + index + 1}
                    </td>
                  </td>
                  <td className="text-nowrap">
                    <HoverTitle
                      title={product.title}
                      imageUrl={`${product.images?.[0]}`}
                    />
                  </td>
                  <td className="fs-6">{product.categoryId?.name}</td>
                  <td>{product.price.toLocaleString()}</td>
                  <td>{product.discount}%</td>
                  <td>{product.stock}</td>

                  <td>
                    {" "}
                    {Array.isArray(product.keywords)
                      ? product.keywords.map((kw, i) => (
                          <span key={i} className="badge bg-primary me-1">
                            {kw}
                          </span>
                        ))
                      : product.keywords}
                  </td>
                  <td>{product.size}</td>

                  <td>{getBrandTitle(product.brand, brands)}</td>
                  <td>
                    <Link to={`/product/${product._id}`} className="cart-icon">
                      <button
                        className="btn btn-sm btn-success me-1"
                        onClick={() => onEdit(product)}
                      >
                        <FaExternalLinkAlt />
                      </button>
                    </Link>

                    <button
                      className="btn btn-sm btn-warning me-1"
                      onClick={() => onEdit(product)}
                    >
                      <FaEdit />
                    </button>
                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() => onDelete(product._id)}
                    >
                      <FaTrash />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="d-flex justify-content-between align-items-center mt-3">
            <div>
              Showing{" "}
              {Math.min((page - 1) * perPage + 1, filteredProducts.length)} to{" "}
              {Math.min(page * perPage, filteredProducts.length)} of{" "}
              {filteredProducts.length} entries
            </div>
            <div className="btn-group">
              <button
                className="btn btn-secondary"
                disabled={page === 1}
                onClick={() => setPage((prev) => prev - 1)}
              >
                Previous
              </button>
              <button
                className="btn btn-secondary"
                disabled={page * perPage >= filteredProducts.length}
                onClick={() => setPage((prev) => prev + 1)}
              >
                Next
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Accordion */}
        <div className="d-lg-none">
          {pagedProducts.map((product) => (
            <div
              key={product._id}
              className="border rounded mb-3 shadow-sm overflow-hidden"
            >
              <div
                className="d-flex justify-content-between align-items-center p-2 bg-light"
                onClick={() => toggleExpand(product._id)}
                role="button"
              >
                <HoverTitle
                  title={product.title}
                  imageUrl={`${product.images?.[0]}`}
                />

                {expanded === product._id ? <ChevronUp /> : <ChevronDown />}
              </div>

              {expanded === product._id && (
                <div className="p-2 small bg-white">
                  <img
                    src={`${product.images?.[0]}`}
                    class="img-fluid"
                    alt="apple"
                  />
                  <div>
                    <strong>Category:</strong>{" "}
                    {getCategoryTitle(product.categoryId, categories)}
                  </div>

                  <div>
                    <strong>Price:</strong> {product.price.toLocaleString()}{" "}
                    تومان
                  </div>
                  <div>
                    <strong>Discount:</strong> {product.discount}%
                  </div>
                  <div>
                    <strong>Stock:</strong> {product.stock}
                  </div>
                  <div>
                    <strong>Color:</strong> {product.color}
                  </div>
                  <div>
                    <strong>Size:</strong> {product.size}
                  </div>
                  <div className="mt-2">
                    <LinearLayout orientation="horizontal">
                      <Link
                        to={`/product/${product._id}`}
                        className="cart-icon"
                      >
                        <button className="btn btn-sm btn-outline-success fs-6 me-1">
                         Product Page
                        </button>
                      </Link>
                      <button
                        onClick={() => onEdit(product)}
                        className="btn btn-sm btn-outline-primary fs-6 me-1"
                      >
                        Edit
                      </button>
                      <button
                        onClick={() => onDelete(product._id)}
                        className="btn btn-sm fs-6 btn-outline-danger"
                      >
                        Delete
                      </button>
                    </LinearLayout>
                  </div>
                </div>
              )}
            </div>
          ))}
          <div className="btn-group">
            <button
              className="btn btn-secondary"
              disabled={page === 1}
              onClick={() => setPage((prev) => prev - 1)}
            >
              Previous
            </button>
            <button
              className="btn btn-secondary"
              disabled={page * perPage >= filteredProducts.length}
              onClick={() => setPage((prev) => prev + 1)}
            >
              Next
            </button>
          </div>
          <div>
            <div className="mt-2">
              Showing{" "}
              {Math.min((page - 1) * perPage + 1, filteredProducts.length)} to{" "}
              {Math.min(page * perPage, filteredProducts.length)} of{" "}
              {filteredProducts.length} entries
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductTable;

